/* eslint-disable */
import moment from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

// import '../ /leaflet/leaflet.js';
// import '../../static/js/leaflet.min.js';
// import '@/utils/leaflet/leaflet.css';
// import '@/utils/googleapis/googlemap.js'; 

const mixinMap = {
  data: () => ({ 
    mapConfig: {
      zoom: 18,
    },
    
    greenPolylineOption: {
      color: '#008e15',
      weight: 4,
      opacity: 0.7
    },
    
    bluePolylineOption: {
      color: '#00b3fd',
      weight: 4,
      opacity: 0.7
    },
    
    redPolylineOption: {
      color: 'red',
      weight: 4,
      opacity: 1
    },
    
    fenceOption: {
      color: 'red',
      weight: 1,
      opacity: 0.2
    },
    
    myLocationFenceOption: {
      color: '#4b96f2',
      weight: 1,
      opacity: 0.2
    },
    
    defaultMarker: null,
    
    myLocationMarker: null,
    
    stoppedMarker: null,

    leaflet: this.$leaflet
  }),

  beforeCreated(){

  },

  created(){
    this.mapConfig = {
      zoom: 18,
      center: this.$leaflet.latLng(10.7589923, 106.67304),
      mapBox: {
        attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
        url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoidHJ1b25nbXYiLCJhIjoiY2pqMW9ldnh6MHVueTNrcGNoZTllNWJmYyJ9.-hB4McZSoCD5zcV_klvR2g',
        mapId: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoidHJ1b25nbXYiLCJhIjoiY2pqMW9ldnh6MHVueTNrcGNoZTllNWJmYyJ9.-hB4McZSoCD5zcV_klvR2g'
      },
      OpenStreetMap: {
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      }
    };
    this.defaultMarker= this.$leaflet.icon({
      iconUrl: 'static/icons/marker.svg',
      iconSize: [40, 40],
      iconAnchor: [20, 40]
    });
    
    this.myLocationMarker= this.$leaflet.icon({
      iconUrl: 'static/icons/mylocation.png',
      iconSize: [24, 24]
    });
    
    this.stoppedMarker= this.$leaflet.icon({
      iconUrl: 'static/icons/stoppedmarker.png',
      iconSize: [40, 40],
      iconAnchor: [20, 40]
    });
  },

  methods: {
    getLatLngFromXY(x, y) {
      return {
        lat: y * Math.pow(10, -6),
        lng: x * Math.pow(10, -6)
      };
    },
    getLatLngFromWaypoint(wp) {
      if (wp != null && wp.x !== undefined && wp.y !== undefined && wp.x != null && wp.y != null) {
        return this.getLatLngFromXY(wp.x, wp.y);
      }
      return {
        lat: 10.763553,
        lng: 106.671185
      };
    },

    isVehicleRunning(vehicle) {
      return vehicle.waypoint.status > 0 && vehicle.waypoint.kmh >= 5;
    },

    isVehicleIdle(vehicle) {
      return vehicle.waypoint.status > 0 && vehicle.waypoint.kmh < 5;
    },

    isVehicleOffline(vehicle) {
      return vehicle.waypoint.status <= 0;
    },

    getVehicleLimitSpeed(vehicle) {
      return vehicle.maxSpeed != null && vehicle.maxSpeed > 0 ? vehicle.maxSpeed : 999;
    },

    isVehicleOverspeed(vehicle) {
      return this.isVehicleRunning(vehicle) && vehicle.waypoint.kmh >this.getVehicleLimitSpeed(vehicle);
    },

    isVehicleDisconnected(vehicle) {
      // let lastTime = moment().diff(DateTimeUtil.convertSecond2010ToDateTime(vehicle.waypoint.time), 'minutes');
      // return (isVehicleIdle(vehicle) && lastTime >= 60) || (isVehicleRunning(vehicle) && lastTime >= 10);
      return !vehicle.waypoint.isConnected
    },

    getVehicleStatus(vehicle) {

      let status = '---';
    
      if (vehicle.waypoint != null) {
    
        let lastTimeString = DateTimeUtil.convertSecondToRelativeTime(vehicle.waypoint.time);
    
        if (this.isVehicleRunning(vehicle)) {
          status = `Đang chạy ${vehicle.waypoint.kmh} Km/h`;
        }
    
        if (this.isVehicleIdle(vehicle)) {
          status = `Dừng ${lastTimeString}`;
        }
    
        if (this.isVehicleOffline(vehicle)) {
          status = `Tắt máy ${lastTimeString}`;
        }
    
        if (this.isVehicleOverspeed(vehicle)) {
          status = `Đang chạy ${vehicle.waypoint.kmh} Km/h (Quá tốc độ)`;
        }
    
        if (this.isVehicleDisconnected(vehicle)) {
          status = `Mất kết nối ${lastTimeString}`;
        }
      }
    
      return status;
    },

    getVehicleIcon(vehicle) {

      // let vehicleType = vehicle.vehicleType === 1 ? 'motor' : 'car';
      let vehicleType = 'symbol';
    
      switch(vehicle.vehicleType){
        case 1: {
          vehicleType = 'motor';
          break;
        }
        case 2: {
          vehicleType = 'car';
          break;
        }
        case 3: {
          vehicleType = 'symbol';
          break;
        }
      }
    
      let runningVehicle = `static/icons/${vehicleType}/green.png`;
      let stoppedVehicle = `static/icons/${vehicleType}/yellow.png`;
      let offlineVehicle = `static/icons/${vehicleType}/black.png`;
      let overspeedVehicle = `static/icons/${vehicleType}/red.png`;
      let disconnectedVehicle = `static/icons/${vehicleType}/gray.png`;
    
      let url = disconnectedVehicle;
    
      if (vehicle.waypoint != null) {
    
        if (this.isVehicleRunning(vehicle)) {
          url = runningVehicle;
        }
    
        if (this.isVehicleIdle(vehicle)) {
          url = stoppedVehicle;
        }
    
        if (this.isVehicleOffline(vehicle)) {
          url = offlineVehicle;
        }
    
        if (this.isVehicleOverspeed(vehicle)) {
          url = overspeedVehicle;
        }
    
        if (this.isVehicleDisconnected(vehicle)) {
          url = disconnectedVehicle;
        }
      }
    
      return url;
    },

    getVehicleIconForHistory(vehicle) {

      // let vehicleType = vehicle.vehicleType === 1 ? 'motor' : 'car';
      let vehicleType = 'symbol';
      switch(vehicle.vehicleType){
        case 1: {
          vehicleType = 'motor';
          break;
        }
        case 2: {
          vehicleType = 'car';
          break;
        }
        case 3: {
          vehicleType = 'symbol';
          break;
        }
      }
    
      let runningVehicle = `static/icons/${vehicleType}/green.png`;
      let stoppedVehicle = `static/icons/${vehicleType}/yellow.png`;
      let offlineVehicle = `static/icons/${vehicleType}/black.png`;
      let overspeedVehicle = `static/icons/${vehicleType}/red.png`;
    
      let url = offlineVehicle;
    
      if (vehicle.waypoint != null) {
    
        if (this.isVehicleRunning(vehicle)) {
          url = runningVehicle;
        }
    
        if (this.isVehicleIdle(vehicle)) {
          url = stoppedVehicle;
        }
    
        if (this.isVehicleOffline(vehicle)) {
          url = offlineVehicle;
        }
    
        if (this.isVehicleOverspeed(vehicle)) {
          url = overspeedVehicle;
        }
      }
    
      return url;
    },

    getVehicleMarkerIcon(vehicle) {

      let url = this.getVehicleIcon(vehicle);
    
      let icon = new this.$leaflet.Icon({
        iconUrl: url,
        iconSize: [50, 50],
      });
    
      let marker = new this.$leaflet.marker(this.getLatLngFromWaypoint(vehicle.waypoint), {
        icon: icon,
        rotationAngle: vehicle.waypoint.heading,
        rotationOrigin: 'center center'
      })
        .bindTooltip(vehicle.plate, {
          permanent: true,
          direction: 'bottom',
          opacity: 1,
          offset: [0, 25]
        });
    
      return marker;
    },

    getVehicleMarkerIconForHistory(vehicle) {

      let url = this.getVehicleIconForHistory(vehicle);
    
      let icon = new this.$leaflet.Icon({
        iconUrl: url,
        iconSize: [50, 50]
      });
    
      let marker = new this.$leaflet.marker(this.getLatLngFromWaypoint(vehicle.waypoint), {
        icon: icon,
        rotationAngle: vehicle.waypoint.heading,
        rotationOrigin: 'center center'
      });
    
      return marker;
    },

    getAddressFromWaypoint(point) {
      let address = 'Không xác định';
      if (point.data) {
        if (point.data.addr !== undefined) {
          address = `${point.data.addr},${point.data.admin}`;
        } else {
          address = point.data.admin;
        }
        address = address.split(',').join(', ');
        point.address = address;
      }
      return address;
    },

    createMapTileLayer(type) {
      if(type === 'vietmap')
        return this.$leaflet.tileLayer('https://maps.vietmap.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=4eefe3dac317876184bd40fc739d3315c559592f1adcb74f', {
          attribution: 'Map data &copy; Vietmap',
          maxZoom: 20,
          maxNativeZoom: 18,
          id: 'vietmap.streets',
      })
      else return new this.$leaflet.gridLayer.googleMutant({ type: type })
    },



  }
};

export default mixinMap;



// WEBPACK FOOTER //
// ./src/mixins/maputil.js